import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function FundraisingLoadErrorNotification(props) {
  const {dismiss, notification} = props;
  const {errorText} = notification;
  return (
    <Notification {...props} title="Heads up!">
      <p> {errorText} </p>
      <Button
        className="notification-cta"
        size="large"
        variant="secondary"
        onClick={dismiss}>
        Okay
      </Button>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    errorText: PropTypes.string,
    productLimit: PropTypes.number
  })
};

FundraisingLoadErrorNotification.propTypes = propTypes;

FundraisingLoadErrorNotification.displayName =
  'FundraisingLoadErrorNotification';
